import { useCreate } from '@refinedev/core';
import { CreateClientPayload } from './useCreateClient';
import { Relation } from './useFamily';

export type CreateFamilyPayload = {
  name: string;
  advisorUserId: string;
  mainFamilyMember: FamilyMemberWithoutRelation;
  secondaryFamilyMembers: FamilyMemberWithRelation[];
};

export type FamilyMemberWithoutRelation =
  | {
      clientId: string;
    }
  | CreateClientPayload;

export type FamilyMemberWithRelation = FamilyMemberWithoutRelation & {
  relationshipToMainFamilyMember: Relation;
};

export function useCreateFamily() {
  const { mutateAsync, error, isLoading, reset } =
    useCreate<CreateFamilyPayload>();

  const createFamily = async (values: CreateFamilyPayload) => {
    return mutateAsync({
      resource: 'families',
      values,
    });
  };

  return {
    createFamily,
    error,
    isLoading,
    reset,
  };
}
